import { gql } from "@apollo/client";

export const BANK_TRANSACTION_FRAGMENT = gql`
  fragment BankTransaction on Transaction {
    bankTxnId
    tenantId
    status
    amount
    currency
    createdAt
    counterpartyName
    counterpartyIban
    purpose
    executionDate
    side
    bookingDate
    smbAttachmentStatus
    invoices {
      invoiceId
      invoiceNo
      totalAmount
      currency
      supplierName
      invoiceDate
    }
    bankConnection {
      bankConnectionId
      metadata {
        id
        bank {
          name
          logo {
            url
          }
          icon {
            url
          }
          bankGroup {
            name
            icon {
              url
            }
            logo {
              url
            }
          }
        }
      }
    }
  }
`;
